import { render } from "./ScreenState.vue?vue&type=template&id=213296e4&scoped=true"
import script from "./ScreenState.vue?vue&type=script&lang=js"
export * from "./ScreenState.vue?vue&type=script&lang=js"

import "./ScreenState.vue?vue&type=style&index=0&id=213296e4&scoped=true&lang=css"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213296e4"]])

export default __exports__